// Pure storage helpers for `<InlineHelp dismissKey="...">`. Extracted
// so the dismissal contract is testable from a node-vitest env (no
// jsdom needed) and so multiple consumers can share the prefix
// without grepping the component file.
//
// Storage shape: each dismissed key writes `"1"` to
// `localStorage["bb:inlineHelpDismissed:<key>"]`. Anything other than
// `"1"` (missing, empty, "0") is treated as "still showing." This
// matches the `bb:` namespacing convention used by the rest of the
// app for browser-buddy-scoped storage entries.

export const INLINE_HELP_DISMISS_PREFIX = "bb:inlineHelpDismissed:";

export function inlineHelpDismissStorageKey(dismissKey: string): string {
  return `${INLINE_HELP_DISMISS_PREFIX}${dismissKey}`;
}

export function readInlineHelpDismissed(dismissKey: string | undefined): boolean {
  if (!dismissKey) return false;
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(inlineHelpDismissStorageKey(dismissKey)) === "1";
  } catch {
    return false;
  }
}

export function writeInlineHelpDismissed(dismissKey: string): void {
  if (!dismissKey) return;
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(inlineHelpDismissStorageKey(dismissKey), "1");
  } catch {
    // localStorage can throw in private-browsing modes / quota cases.
    // We silently no-op so the popover still closes; the user just
    // won't get the persistence on this device.
  }
}

export function clearInlineHelpDismissed(dismissKey: string): void {
  if (!dismissKey) return;
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(inlineHelpDismissStorageKey(dismissKey));
  } catch {
    // see writeInlineHelpDismissed
  }
}
